module.exports = __webpack_public_path__ + "media/organizations/TUberlin-eb0a492b.webp";